<template>
<v-select :loading="loading" :value="value" :items="items" item-text="title" item-value="value" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" no-data-text="اطلاعاتی موجود نیست..." @input="v => $emit('input', v)"
  @change="v => $emit('input', v)" />
</template>

<script>
import getCostsName from '../functions/costsName'
import getIncomesName from '../functions/incomesName'

export default {
  name: 'MyDiscount',
  props: {
    value: {
      required: true
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      requiredRules: [v => !!v || 'فیلد الزامی'],
      firstSelected: false // کنترل اینکه فقط یکبار انتخاب پیش‌فرض شود
    }
  },
  methods: {
    makeItem(title, label, _id) {
      return {
        title,
        value: {
          label,
          _id
        }
      }
    },
    async retrieveData() {
      this.loading = true
      try {
        const [costs, incomes] = await Promise.all([
          getCostsName(),
          getIncomesName()
        ])

        this.items = [
          ...(costs?.length ? [this.makeItem('هزینه', 'cost_id', costs[0]._id)] : []),
          ...(incomes?.length ? [this.makeItem('درآمد', 'income_id', incomes[0]._id)] : [])
        ]

        this.loading = false
        this.selectFirst() // فقط بار اول
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    },
    selectFirst() {
      if (this.value !== 1 || this.firstSelected || !this.items.length) return
      setTimeout(() => {
        const first = this.items[0]
        this.$emit('input', first.value)
        this.firstSelected = true
      }, 50)
    }
  },
  async created() {
    await this.retrieveData()
  }
}
</script>
